import React, { memo /*  useEffect, useMemo, */ } from "react";
import cx from "classnames";
import BlankState from "@ui/BlankStateV2";
import { Dashboard, Dataset } from "@ui/Illustration/react";
import { colors, shadows, spacings } from "@ui/Theme";
import { css } from "@linaria/core";
import { useDashboardEditorContext } from "../../../../hook/context/editor";
// import type { DashboardBlockModelT } from "../../../../schema/dashboard";
// import { useDashboardUnsaved } from "../../../../hook/useDashboardUnsaved";
// import useDebouncedCallback from "../../../../../../../lib/hooks/useDebouncedCallback";
import t from "../../../../../../../i18n";
import { PlotEditor } from "./PlotEditor";
// import { JSONEditor } from "./JSONEditor";
import { usePreset } from "../Block/Plot/hook/usePreset";
import { ImageEditor } from "./ImageEditor";
import { DiagramEditor } from "./DiagramEditor";
import { PriorityFaultEventsEditor } from "./PriorityFaultEventsEditor";

/**
 * @todo Fine tune the debounce window from keyboard events
 */
// const EDITOR_UPDATE_DEBOUNCE_WINDOW = 500;

const dashboardEditor = css`
  background-color: ${colors.hydrogen};
  box-shadow: ${shadows.shadow200};
  height: calc(100vh - var(--primary-header-height));
  overflow-y: scroll;
  overscroll-behavior: contain;
  padding-top: ${spacings.xl};
  padding-top: 0;
  padding: ${spacings.xl} 0;
  width: var(--dashboard-editor-width);
  z-index: 3;
`;

export const DashboardEditor = memo(
  ({ projectId, className }: { projectId: string; className?: string }) => {
    const editor = useDashboardEditorContext();
    const preset = usePreset(editor?.block);
    return (
      <aside className={cx(dashboardEditor, className)}>
        {editor?.block ? (
          <>
            {editor.block.kind === "PLOT" && preset && (
              <PlotEditor projectId={projectId} preset={preset} />
            )}
            {editor.block.kind === "IMAGE" && <ImageEditor projectId={projectId} />}
            {editor.block.kind === "DIAGRAM" && <DiagramEditor projectId={projectId} />}
            {editor.block.kind === "PRESET" &&
              editor.block.data.preset === "PRIORITY_FAULT_EVENTS" && <PriorityFaultEventsEditor />}
            {editor.block.kind !== "PLOT" &&
              editor.block.kind !== "IMAGE" &&
              editor.block.kind !== "DIAGRAM" &&
              (editor.block.kind !== "PRESET" ||
                editor.block.data.preset !== "PRIORITY_FAULT_EVENTS") && (
                <BlankState
                  title={t("project.dashboard.editor.no_editor.title")}
                  subtitle={
                    editor.block.kind === "PRESET"
                      ? null
                      : t("project.dashboard.editor.no_editor.subtitle")
                  }
                  picto={<Dashboard size="m" />}
                />
              )}
          </>
        ) : (
          <BlankState
            title={t("project.dashboard.editor.blank_state.title")}
            subtitle={t("project.dashboard.editor.blank_state.subtitle")}
            picto={<Dataset size="m" />}
          />
        )}
      </aside>
    );
  },
);
